import React, { useState, useEffect } from 'react';
import SectionTitleBar from '../../../components/titlebar';
import { BaseReact } from '../../../../base.model';
import { ProfileQL } from '../../../../models/Profile';
import { ReportGenerationArgs, ReportJob, ReportMergeBundle } from '../../../../models/Report';

import './Ordenes.reporte.generation.scss';
import { useLazyQuery } from '@apollo/client';
import { graphqlSchema } from '../../../../services/graphql.schema';
import OrdenesReportGenerationRundown from './Ordenes.reporte.generation.rundown';
import { useParams } from 'react-router-dom';

interface ReportOrderProps extends BaseReact {
    currentUser: ProfileQL;
}

function OrdenesReportGeneration({ currentUser, history, location, match }: ReportOrderProps) {

    const { reportid } = useParams<{ reportid: string }>();

    const [generating, setGenerating] = useState(true);
    const [isLoading, setLoading] = useState(true);
    const [generatorArgs, setgGeneratorArgs] = useState<ReportGenerationArgs>(null)
    const [reportBundle, setReportBundle] = useState<ReportMergeBundle[]>([]);

    // ====== Progress states

    const [progressOrders, setProgressOrders] = useState(false);
    const [progressProducts, setProgressProducts] = useState(false);

    const [progCountPedidos ] = useState(0);
    const [progCountProductos ] = useState(0);
    const [progCountBills ] = useState(0);


    const [getReportJob] = useLazyQuery(graphqlSchema.PROFILE.REPORTS.getReportJob, {
        onCompleted: ({ getReportJob }: { getReportJob: ReportJob }) => {
            console.log('Get Job Report: ', getReportJob);
            if (!getReportJob.dataUrl) {
                setGenerating(true);
            } else if (getReportJob.dataUrl) {
                fetch(`${getReportJob.dataUrl}`)
                    .then((d) => d.json())
                    .then((d) => {
                        const genArgs:ReportGenerationArgs = {
                            dateStart: getReportJob.startDate,
                            dateEnd: getReportJob.endDate,
                            ...getReportJob.templateIs,
                        }
                        setgGeneratorArgs(genArgs)
                        setReportBundle(d);
                        setProgressOrders(true)
                        setProgressProducts(true)
                        setLoading(false);
                    })
            }

        },
        onError: (e) => {
            console.error('Error getting Report Job: ', e);
        }
    })

    useEffect(() => {
        getReportJob({
            variables: {
                reportid
            }
        })
    }, [getReportJob, reportid]);

    useEffect(() => {
        if(!isLoading){
            console.log('UE Loading: ');
            setTimeout(() => {
                setGenerating(false);
            }, 550)
        }
    }, [isLoading])


    const renderProgress = () => {
        return (
            <div className="reporteContent">
                <div className={`progressLoading ${isLoading ? 'executing' : 'done'}`}>
                    <div className="progressBar">

                        <div className={`barItself ${!progressOrders && 'uncertain'}`} ></div>
                    </div>
                    <div className="progressReport">
                        {
                            !progressOrders ?
                                <h1>Iniciando reporte</h1>
                                :
                                <h1>{30}% completado</h1>
                        }
                        <div className="rotationalSpinner">
                            <p className={`one ${!progressOrders ? 'active' : (progressOrders && !progressProducts ? 'minusOne' : 'minusTwo')}`}>Cargando {progCountPedidos} pedidos</p>
                            <p className={`two ${!progressOrders ? 'plusOne' : (progressOrders && !progressProducts ? 'active' : 'minusOne')}`}>Obteniendo {progCountProductos} productos</p>
                            <p className={`three ${!progressOrders ? 'plusTwo' : (progressOrders && !progressProducts ? 'plusOne' : 'active')}`}>Obteniendo {progCountBills} facturas</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div id="OrdenesReporteGenerator">
            <SectionTitleBar currentUser={currentUser} title="Generar Reporte de pedidos" />
            {
                generating ?
                    renderProgress()
                    :
                    <OrdenesReportGenerationRundown mergeBundle={reportBundle} report={generatorArgs} currentUser={currentUser} history={history} location={location} match={match} />
            }
        </div >
    )
}

export default OrdenesReportGeneration;